import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }


  render() {
    if (this.state.hasError) {
      return (
        <div className={styles['error-boundary']}>
          <h1>Xəta baş verdi</h1>
          <p>Zəhmət olmasa səhifəni yeniləyin və ya daha sonra yenidən cəhd edin.</p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary"
          >
            Səhifəni yeniləyin
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundary; 